import _get from 'lodash/get'
import Mola from '../api/mola'
import types from '../constants'

export const getInbox = (params = {}) => (dispatch, getState) => {
  return new Promise(resolve => {
    const limit = _get(params, 'limit', 5)
    const stateInbox = _get(getState(), 'inbox.inbox.data', [])
    const statePage = _get(getState(), 'inbox.inbox.meta.page', 1)
    const token = _get(getState(), 'user.token', '')

    let loadingState = true

    const _getQueryString = () => {
      const isNext = _get(params, 'next', false)
      if (isNext) {
        loadingState = false
      }
      let queryString = {
        ...params,
        size: limit,
        page: isNext ? statePage + 1 : 1,
      }
      return queryString
    }

    const qs = _getQueryString()
    dispatch({
      type: types.GET_INBOX_LOADING,
      payload: {
        meta: {
          page: statePage,
          status: 'loading',
          error: '',
          haveNextPage: false,
          loadingState: loadingState
        },
        data: stateInbox
      },
    })

    return Mola.getInbox(qs, token)
      .then(result => {
        if (result.meta.status === 'error') {
          dispatch({
            type: types.GET_INBOX_ERROR,
            payload: {
              meta: {
                page: statePage,
                status: 'error',
                error: _get(result, 'meta.error', 'Oops something wrong!'),
                haveNextPage: false,
              },
              data: stateInbox
            },
          })

          return resolve({
            nextPage: false,
            data: stateInbox,
          })
        } else {
          const resultInbox = _get(result, 'data', [])
          const _getResult = () => {
            let results
            const isResetInbox = _get(params, 'next', false) === false

            if (isResetInbox) {
              results = [...resultInbox.slice(0, limit)]
            } else {
              results = [...stateInbox, ...resultInbox.slice(0, limit)]
            }
            return results
          }

          const results = _getResult()
          dispatch({
            type: types.GET_INBOX_SUCCESS,
            payload: {
              meta: {
                page: qs.page,
                status: 'success',
                error: '',
                haveNextPage: resultInbox.length > limit,
              },
              data: results,
            },
          })

          return resolve({
            nextPage: resultInbox.length > limit,
            data: results,
          })
        }
      })
      .catch(err => {
        dispatch({
          type: types.GET_INBOX_ERROR,
          payload: {
            meta: {
              page: statePage,
              status: 'error',
              error: err || 'Oops something wrong!',
              haveNextPage: false,
            },
            data: stateInbox
          },
        })

        return resolve({
          nextPage: false,
          data: stateInbox,
        })
      })
  })
}

export const getInboxDetail = (params = {}) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  dispatch({
    type: types.GET_INBOX_DETAIL_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
    },
  })
  return Mola.getInboxDetail(params, token)
    .then(result => {
      if (result.meta.status === 'error') {
        dispatch({
          type: types.GET_INBOX_DETAIL_ERROR,
          payload: {
            meta: {
              status: 'error',
              error: _get(result, 'meta.error', 'Oops something wrong!'),
            },
          },
        })
      } else if (result.meta.status === 'success') {
        dispatch({
          type: types.GET_INBOX_DETAIL_SUCCESS,
          payload: {
            meta: {
              status: 'success',
              error: '',
            },
            data: _get(result, 'data', null),
          },
        })
      }
    })
    .catch(err => {
      dispatch({
        type: types.GET_INBOX_DETAIL_ERROR,
        payload: {
          meta: {
            status: 'error',
            error: err || 'Oops something wrong!',
          },
        },
      })
    })
}

export const changeInboxFilter = (value) => {
  return {
    type: types.INBOX_FILTER_ACTIVE,
    payload: value
  }
}

export const changeNotifBadgesInboxTour = (value) => {
  return {
    type: types.INBOX_NOTIF_BADGES_TOUR,
    payload: value
  }
}

export const getInboxCategory = () => (dispatch, getState) => {
  const categoryActive = _get(getState(), 'inbox.category.categoryActive', 0)
  dispatch({
    type: types.GET_INBOX_CATEGORY_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
      categoryActive
    },
  })
  return Mola.getInboxCategory()
    .then((result) => {
      if (result.meta.status === 'error') {
        dispatch({
          type: types.GET_INBOX_CATEGORY_ERROR,
          payload: {
            meta: {
              status: 'error',
              error: _get(result, 'meta.error', 'Oops something wrong!'),
            },
            categoryActive
          },
        })
      } else if (result.meta.status === 'success') {
        let data = _get(result, 'data', [])
        const allCategory = {
          id: 0,
          type: 'category',
          name: 'All',
          description: 'Semua Kategori',
          displayOrder: 0
        }
        data.push(allCategory)
        dispatch({
          type: types.GET_INBOX_CATEGORY_SUCCESS,
          payload: {
            meta: {
              status: 'success',
              error: '',
            },
            data: data,
            categoryActive
          },
        })
      }
    })
    .catch(err => {
      dispatch({
        type: types.GET_INBOX_CATEGORY_ERROR,
        payload: {
          meta: {
            status: 'error',
            error: err || 'Oops something wrong!',
          },
          categoryActive
        },
      })
    })
}

export const changeCategoryActive = (categoryId) => {
  return {
    type: types.CHANGE_CATEGORY_ACTIVE,
    payload: categoryId
  }
}

export const getCounterInbox = () => (dispatch, getState) => {
  const stateCounter = _get(getState(), 'inbox.counter.data', { unread: 0 })
  const token = _get(getState(), 'user.token', '')
  dispatch({
    type: types.GET_COUNTER_INBOX_LOADING,
    payload: {
      meta: {
        status: 'loading'
      },
      data: stateCounter
    }
  })
  return Mola.getCounterInbox(token)
    .then((response) => {
      let data = _get(response, 'data', 0)
      dispatch({
        type: types.GET_COUNTER_INBOX_SUCCESS,
        payload: {
          meta: {
            status: 'success'
          },
          data: data
        }
      })
    })
    .catch(err => {
      dispatch({
        type: types.GET_FEATURE_ARTICLE_ERROR,
        payload: {
          meta: {
            status: 'error',
            error: err || 'error get counter'
          },
          data: stateCounter
        }
      })
    })
}

export default {
  getInbox,
  getInboxDetail,
  changeInboxFilter,
  changeNotifBadgesInboxTour,
  getInboxCategory,
  changeCategoryActive,
  getCounterInbox
}
